{
  "en": {
    "helpTitle": "Help",
    "helpText": "This text is used to provide help to the user.",
    "langSelector": "Select Language:",
    "test": "Hello World",
    "welcomeMsg":"Welcome to Trinkle WebComponents demo app",
    "param.blueness": "Blue",
    "marketingOffer":"Get 20% off your first purchase!",
    "parameters.step1.red-color":"Red",
    "apps.general.exit-without-saving": "You are about to exit with unsaved changes. Your progress will be lost. Do you want to continue?",
    "tooltip.view.perspective": "Toggle perspective view",
    "tooltip.view.fit": "Fit to screen",
    "tooltip.view.iso": "Isometric view",
    "tooltip.view.front": "Toggle front/back view",
    "tooltip.view.right": "Toggle right/left view",
    "tooltip.view.top": "Toggle top/bottom view",
    "tooltip.apps.home": "Back to App Suite",
    "tooltip.state.undo": "Undo",
    "tooltip.state.redo": "Redo",
    "tooltip.session.new": "New session",
    "tooltip.session.restore": "Restore session",
    "tooltip.session.save": "Save session",
    "base.app.title": "Demo",
    "Base.ErrorHeader": "Error",
    "Base.ErrorInfo.ErrorDescription.Generic": "An unexpected error occurred",
    "errorPanel.label.timestamp": "Timestamp",
    "errorPanel.label.sessionId": "Session ID",
    "errorPanel.label.error": "Error",
    "errorPanel.label.serverCode": "Server Code",
    "Base.ErrorPanel.Button.CopyToClipboard": "Copy to Clipboard",
    "Base.ErrorPanel.Button.Undo": "Undo",
    "paramateError.serviceInterrupted.title": "Service Interrupted",
    "paramateError.serviceInterrupted.message": "A service was interrupted due to a loss of internet connection. Please check your connection and try again.",
    "paramateError.unsupportedFileFormat.title": "Unsupported File Format",
    "paramateError.unsupportedFileFormat.message": "The uploaded file format is not supported. Please upload a file in a supported format.",
    "paramateError.fileTooComplex.title": "File Too Complex to Process",
    "paramateError.fileTooComplex.message": "The uploaded file seems to be too complex to process. STEP/3MF files can expand significantly upon conversion and may exceed the supported limit. Please suppress any unwanted geometry in your CAD software, export the file as an STL, and upload it again. The recommended file size is under 10 MB.",
    "paramateError.sessionFileNotRecognized.title": "Session File Not Recognized",
    "paramateError.sessionFileNotRecognized.message": "The provided file could not be restored as a session. Please check your file, it may be incompatible.",
    "paramateError.saveOperationTimeout.title": "Save Operation Timeout",
    "paramateError.saveOperationTimeout.message": "The file could not be saved. The operation exceeded the expected time limit. If you have STEP export enabled, switching to STL may help. Reducing the export scope by selecting only the models you need may also speed things up. Please try again.",
    "paramateError.operationTimeout.title": "Operation Timeout",
    "paramateError.operationTimeout.message": "The current operation could not be completed. The process exceeded the expected time limit.",
    "paramateError.unexpectedError.title": "Unexpected Error",
    "paramateError.unexpectedError.message": "An unexpected error occurred on the server. Please try again later.",
    "paramateError.meshTransferFailed.title": "Mesh Transfer Failed",
    "paramateError.meshTransferFailed.message": "The mesh could not be transferred. The file may be too large, malformed, or incompatible with the target application.",
    "paramateError.grabcadTransferFailed.title": "Transfer Failed",
    "paramateError.grabcadTransferFailed.message": "The transfer to GrabCAD could not be completed. Please save your session and try again later. Alternatively, you can export the file and upload it to GrabCAD Print Pro manually.",
    "Base.AppTitle": "App Suite",
    "tooltip.feature.help": "Help",
    "tooltip.feature.settings": "Options",
    "tooltip.feature.toggle-workpiece-view": "Show/Hide Workpiece",
    "tooltip.feature.transfer-mesh": "Transfer Mesh",
    "notifications.demo.title": "Notification Examples",
    "notifications.demo.info.button": "Show Info Notification",
    "notifications.demo.success.button": "Show Success Notification",
    "notifications.demo.warning.button": "Show Warning Notification",
    "notifications.demo.error.button": "Show Error Notification",
    "notifications.demo.trigger-error.button": "Trigger Error",
    "notifications.demo.persistent.button": "Show Persistent Notification",
    "notifications.demo.timeout.button": "Custom Timeout (10s)",
    "notifications.demo.clear.button": "Clear All Notifications",
    "notifications.demo.info.message": "This is an info notification",
    "notifications.demo.success.message": "This is a success notification",
    "notifications.demo.warning.message": "This is a warning notification",
    "notifications.demo.error.message": "This is an error notification",
    "notifications.demo.persistent.message": "This is a persistent notification",
    "notifications.demo.timeout.message": "This is a custom timeout notification",
    "notifications.mesh.transfer.save.success": "Mesh saved successfully",
    "notifications.mesh.transfer.save.error": "Mesh save failed",
    "notifications.mesh.autoload.detected": "Mesh detected",
    "translations.demo": "This text will be automatically translated.",
    "footer.trinckle-label": "trinckle design automation application | Powered by paramate"
  },
  "de": {
    "helpTitle": "Hilfe",
    "helpText": "Dieser Text wird verwendet, um Hilfe für den Benutzer bereitzustellen.",
    "langSelector": "Sprache auswählen:",
    "test": "Hallo Welt",
    "welcomeMsg":"Willkommen bei der Trinkle WebComponents Demo-App.",
    "param.blueness": "Blau",
    "marketingOffer":"Erhalten Sie 20% Rabatt auf Ihre erste Bestellung!",
    "apps.general.exit-without-saving": "Sie sind dabei, mit ungespeicherten Änderungen zu beenden. Ihr Fortschritt geht verloren. Möchten Sie fortfahren?",
    "tooltip.view.perspective": "Perspektivische Ansicht umschalten.",
    "tooltip.view.fit": "An Bildschirm anpassen.",
    "tooltip.view.iso": "Isometrische Ansicht.",
    "tooltip.view.front": "Vorder-/Rückansicht umschalten.",
    "tooltip.view.right": "Rechts-/Linksansicht umschalten.",
    "tooltip.view.top": "Oben-/Untenansicht umschalten.",
    "tooltip.apps.home": "Zurück zur App Suite.",
    "tooltip.state.undo": "Rückgängig.",
    "tooltip.state.redo": "Wiederholen.",
    "tooltip.session.new": "Neue Sitzung.",
    "tooltip.session.restore": "Sitzung wiederherstellen.",
    "tooltip.session.save": "Sitzung speichern.",
    "base.app.title": "Demo (DE)",
    "Base.ErrorHeader": "Fehler",
    "Base.ErrorInfo.ErrorDescription.Generic": "Ein unerwarteter Fehler ist aufgetreten",
    "errorPanel.label.timestamp": "Zeitstempel",
    "errorPanel.label.sessionId": "Sitzungs-ID",
    "errorPanel.label.error": "Fehler",
    "errorPanel.label.serverCode": "Server-Code",
    "Base.ErrorPanel.Button.CopyToClipboard": "In die Zwischenablage kopieren",
    "Base.ErrorPanel.Button.Undo": "Rückgängig",
    "Base.AppTitle": "App Suite",
    "tooltip.feature.help": "Hilfe",
    "tooltip.feature.settings": "Optionen",
    "tooltip.feature.toggle-workpiece-view": "Werkstück anzeigen/ausblenden",
    "tooltip.feature.transfer-mesh": "Netz übertragen",
    "notifications.demo.title": "Benachrichtigung Beispiele",
    "notifications.demo.info.button": "Info Benachrichtigung anzeigen",
    "notifications.demo.success.button": "Erfolg Benachrichtigung anzeigen",
    "notifications.demo.warning.button": "Warnung Benachrichtigung anzeigen",
    "notifications.demo.error.button": "Fehler Benachrichtigung anzeigen",
    "notifications.demo.trigger-error.button": "Fehler auslösen",
    "notifications.demo.persistent.button": "Langfristige Benachrichtigung anzeigen",
    "notifications.demo.timeout.button": "Timeout (10s)",
    "notifications.demo.clear.button": "Alle Benachrichtigungen löschen",
    "notifications.demo.info.message": "Dies ist eine Info-Benachrichtigung",
    "notifications.demo.success.message": "Dies ist eine Erfolg-Benachrichtigung",
    "notifications.demo.warning.message": "Dies ist eine Warnung-Benachrichtigung",
    "notifications.demo.error.message": "Dies ist eine Fehler-Benachrichtigung",
    "notifications.demo.persistent.message": "Dies ist eine Langfristige-Benachrichtigung",
    "notifications.demo.timeout.message": "Dies ist eine Timeout-Benachrichtigung",
    "notifications.mesh.transfer.save.success": "Netz erfolgreich gespeichert",
    "notifications.mesh.transfer.save.error": "Netz speichern fehlgeschlagen",
    "notifications.mesh.autoload.detected": "Netz erkannt",
    "translations.demo": "Dieser Text wird automatisch übersetzt.",
    "widgets.title": "Widgets"
  },
  "es": {
    "helpTitle": "Ayuda",
    "helpText": "Este texto se utiliza para proporcionar ayuda al usuario.",
    "langSelector": "Seleccionar idioma:",
    "test": "Hola Mundo",
    "welcomeMsg":"Bienvenido a la aplicación de demostración de Trinkle WebComponents.",
    "param.blueness": "Azul",
    "marketingOffer":"Obtenga un descuento del 20% en su primera compra!",
    "apps.general.exit-without-saving": "Estás a punto de salir con cambios sin guardar. Se perderá tu progreso. ¿Quieres continuar?",
    "tooltip.view.perspective": "Alternar vista en perspectiva.",
    "tooltip.view.fit": "Ajustar a la pantalla.",
    "tooltip.view.iso": "Vista isométrica.",
    "tooltip.view.front": "Alternar vista frontal/trasera.",
    "tooltip.view.right": "Alternar vista derecha/izquierda.",
    "tooltip.view.top": "Alternar vista superior/inferior.",
    "tooltip.apps.home": "Volver al Suite de Aplicaciones.",
    "tooltip.state.undo": "Deshacer.",
    "tooltip.state.redo": "Rehacer.",
    "tooltip.session.new": "Nueva sesión.",
    "tooltip.session.restore": "Restaurar sesión.",
    "tooltip.session.save": "Guardar sesión.",
    "base.app.title": "Demo (ES)",
    "Base.ErrorHeader": "Error",
    "Base.ErrorInfo.ErrorDescription.Generic": "Se ha producido un error inesperado",
    "errorPanel.label.timestamp": "Hora",
    "errorPanel.label.sessionId": "ID de sesión",
    "errorPanel.label.error": "Error",
    "errorPanel.label.serverCode": "Código de servidor",
    "Base.ErrorPanel.Button.CopyToClipboard": "Copiar al portapapeles",
    "Base.ErrorPanel.Button.Undo": "Deshacer",
    "Base.AppTitle": "Suite de Aplicaciones",
    "tooltip.feature.help": "Ayuda",
    "tooltip.feature.settings": "Opciones",
    "tooltip.feature.toggle-workpiece-view": "Mostrar/Ocultar Pieza",
    "tooltip.feature.transfer-mesh": "Transferir Malla",
    "notifications.demo.title": "Ejemplos de notificaciones",
    "notifications.demo.info.button": "Mostrar notificación de información",
    "notifications.demo.success.button": "Mostrar notificación de éxito",
    "notifications.demo.warning.button": "Mostrar notificación de advertencia",
    "notifications.demo.error.button": "Mostrar notificación de error",
    "widgets.title": "Widgets"
  }, 
  "fr": {
    "helpTitle": "Aide",
    "helpText": "Ce texte est utilisé pour fournir de l'aide au utilisateur.",
    "langSelector": "Sélectionner la langue:",
    "test": "Bonjour le monde",
    "welcomeMsg":"Bienvenue dans l'application de démonstration de Trinkle WebComponents.",
    "param.blueness": "Bleu",
    "apps.general.exit-without-saving": "Vous êtes sur le point de quitter avec des modifications non enregistrées. Votre progression sera perdue. Voulez-vous continuer?",
    "tooltip.view.perspective": "Basculer la vue en perspective.",
    "tooltip.view.fit": "Ajuster à l'écran.",
    "tooltip.view.iso": "Vue isométrique.",
    "tooltip.view.front": "Basculer la vue avant/arrière.",
    "tooltip.view.right": "Basculer la vue droite/gauche.",
    "tooltip.view.top": "Basculer la vue supérieure/inférieure.",
    "tooltip.apps.home": "Retour à la Suite d'Applications.",
    "tooltip.state.undo": "Annuler.",
    "tooltip.state.redo": "Rétablir.",
    "tooltip.session.new": "Nouvelle session.",
    "tooltip.session.restore": "Restaurer la session.",
    "tooltip.session.save": "Enregistrer la session.",
    "base.app.title": "Demo (FR)",
    "Base.ErrorHeader": "Erreur",
    "Base.ErrorInfo.ErrorDescription.Generic": "Une erreur inattendue s'est produite",
    "errorPanel.label.timestamp": "Horodatage",
    "errorPanel.label.sessionId": "ID de session",
    "errorPanel.label.error": "Erreur",
    "errorPanel.label.serverCode": "Code serveur",
    "Base.ErrorPanel.Button.CopyToClipboard": "Copier dans le presse-papiers",
    "Base.ErrorPanel.Button.Undo": "Annuler",
    "Base.AppTitle": "Suite d'Applications",
    "tooltip.feature.help": "Aide",
    "tooltip.feature.settings": "Options",
    "tooltip.feature.toggle-workpiece-view": "Afficher/Masquer la pièce",
    "tooltip.feature.transfer-mesh": "Transférer le maillage",
    "notifications.demo.title": "Exemples de notifications",
    "notifications.demo.info.button": "Afficher la notification d'information",
    "notifications.demo.success.button": "Afficher la notification de succès",
    "notifications.demo.warning.button": "Afficher la notification de préavis",
    "notifications.demo.error.button": "Afficher la notification d'erreur",
    "notifications.demo.persistent.button": "Afficher la notification persistante",
    "notifications.demo.timeout.button": "Timeout (10s)",
    "notifications.demo.trigger-error.button": "Afficher la notification d'erreur",
    "notifications.demo.clear.button": "Effacer toutes les notifications",
    "notifications.demo.info.message": "Cette notification est une notification d'information",
    "notifications.demo.success.message": "Cette notification est une notification de succès",
    "notifications.demo.warning.message": "Cette notification est une notification de préavis",
    "notifications.demo.error.message": "Cette notification est une notification d'erreur",
    "notifications.demo.persistent.message": "Cette notification est une notification persistante",
    "notifications.demo.timeout.message": "Cette notification est une notification de timeout",
    "notifications.mesh.transfer.save.success": "Métier sauvegardé avec succès",
    "notifications.mesh.transfer.save.error": "Erreur lors de la sauvegarde du métier",
    "notifications.mesh.autoload.detected": "Métier détecté",
    "translations.demo": "Ce texte sera traduit automatiquement.",
    "widgets.title": "Widgets"
  },
  "jp": {
    "helpTitle": "ヘルプ",
    "helpText": "このテキストはユーザーに支援を提供するために使用されます。",
    "langSelector": "言語を選択してください:",
    "test": "こんにちは世界",
    "welcomeMsg":"Trinkle WebComponents デモアプリケーションへようこそ。",
    "param.blueness": "青",
    "apps.general.exit-without-saving": "保存されていない変更があります。終了するとプログレスが失われます。続行しますか？",
    "tooltip.view.perspective": "透視図表示を切り替え。",
    "tooltip.view.fit": "画面に合わせる。",
    "tooltip.view.iso": "等角投影図。",
    "tooltip.view.front": "前面/背面表示を切り替え。",
    "tooltip.view.right": "右/左表示を切り替え。",
    "tooltip.view.top": "上/下表示を切り替え。",
    "tooltip.apps.home": "アプリスイートに戻る。",
    "tooltip.state.undo": "元に戻す。",
    "tooltip.state.redo": "やり直す。",
    "tooltip.session.new": "新しいセッション。",
    "tooltip.session.restore": "セッションを復元。",
    "tooltip.session.save": "セッションを保存。",
    "base.app.title": "デモ (JP)",
    "Base.ErrorHeader": "エラー",
    "Base.ErrorInfo.ErrorDescription.Generic": "予期せぬエラーが発生しました",
    "errorPanel.label.timestamp": "タイムスタンプ",
    "errorPanel.label.sessionId": "セッションID",
    "errorPanel.label.error": "エラー",
    "errorPanel.label.serverCode": "サーバーコード",
    "Base.ErrorPanel.Button.CopyToClipboard": "クリップボードにコピー",
    "Base.ErrorPanel.Button.Undo": "元に戻す",
    "Base.AppTitle": "アプリスイート",
    "tooltip.feature.help": "ヘルプ",
    "tooltip.feature.settings": "オプション",
    "tooltip.feature.toggle-workpiece-view": "ワークピースを表示/非表示",
    "tooltip.feature.transfer-mesh": "メッシュを転送",
    "notifications.demo.title": "通知例",
    "notifications.demo.info.button": "情報通知を表示",
    "notifications.demo.success.button": "成功通知を表示",
    "notifications.demo.warning.button": "警告通知を表示",
    "notifications.demo.error.button": "エラー通知を表示",
    "notifications.demo.persistent.button": "持続通知を表示",
    "notifications.demo.timeout.button": "タイムアウト (10s)",
    "notifications.demo.clear.button": "すべての通知をクリア",
    "notifications.demo.info.message": "これは情報通知です",
    "notifications.demo.success.message": "これは成功通知です",
    "notifications.demo.warning.message": "これは警告通知です",
    "notifications.demo.error.message": "これはエラー通知です",
    "notifications.demo.persistent.message": "これは持続通知です",
    "notifications.demo.timeout.message": "これはタイムアウト通知です",
    "notifications.mesh.transfer.save.success": "メッシュが正常に保存されました",
    "notifications.mesh.transfer.save.error": "メッシュの保存に失敗しました",
    "notifications.mesh.autoload.detected": "メッシュが検出されました"
  },
  "cn":{
    "helpTitle": "帮助",
    "helpText": "此文本用于向用户提供帮助。",
    "langSelector": "选择语言:",
    "test": "你好世界",
    "welcomeMsg":"欢迎来到Trinkle WebComponents演示应用程序。",
    "param.blueness": "蓝色",
    "apps.general.exit-without-saving": "您即将退出，但有未保存的更改。您的进度将丢失。您要继续吗？",
    "tooltip.view.perspective": "切换透视视图。",
    "tooltip.view.fit": "适合屏幕。",
    "tooltip.view.iso": "等轴测视图。",
    "tooltip.view.front": "切换前视图/后视图。",
    "tooltip.view.right": "切换右视图/左视图。",
    "tooltip.view.top": "切换顶视图/底视图。",
    "tooltip.apps.home": "返回应用套件。",
    "tooltip.state.undo": "撤销。",
    "tooltip.state.redo": "重做。",
    "tooltip.session.new": "新会话。",
    "tooltip.session.restore": "恢复会话。",
    "tooltip.session.save": "保存会话。",
    "base.app.title": "演示 (CN)",
    "Base.ErrorHeader": "错误",
    "Base.ErrorInfo.ErrorDescription.Generic": "发生意外错误",
    "errorPanel.label.timestamp": "时间戳",
    "errorPanel.label.sessionId": "会话ID",
    "errorPanel.label.error": "错误",
    "errorPanel.label.serverCode": "服务器代码",
    "Base.ErrorPanel.Button.CopyToClipboard": "复制到剪贴板",
    "Base.ErrorPanel.Button.Undo": "撤销",
    "Base.AppTitle": "应用套件",
    "tooltip.feature.help": "帮助",
    "tooltip.feature.settings": "选项",
    "tooltip.feature.toggle-workpiece-view": "显示/隐藏工件",
    "tooltip.feature.transfer-mesh": "传输网格",
    "notifications.demo.title": "通知示例",
    "notifications.demo.info.button": "显示信息通知",
    "notifications.demo.success.button": "显示成功通知",
    "notifications.demo.warning.button": "显示警告通知",
    "notifications.demo.error.button": "显示错误通知",
    "notifications.demo.persistent.button": "显示持久通知",
    "notifications.demo.timeout.button": "超时 (10s)",
    "notifications.demo.clear.button": "清除所有通知",
    "notifications.demo.info.message": "这是一个信息通知",
    "notifications.demo.success.message": "这是一个成功通知",
    "notifications.demo.warning.message": "这是一个警告通知",
    "notifications.demo.error.message": "这是一个错误通知",
    "notifications.demo.persistent.message": "这是一个持久通知",
    "notifications.demo.timeout.message": "这是一个超时通知",
    "notifications.mesh.transfer.save.success": "网格保存成功",
    "notifications.mesh.transfer.save.error": "网格保存失败",
    "notifications.mesh.autoload.detected": "检测到网格",
    "notifications.mesh.autoload.error": "无法检测到网格",
    "notifications.mesh.autoload.timeout": "检测超时"
  },
  "it":{
    "helpTitle": "Aiuto",
    "helpText": "Questo testo viene utilizzato per fornire aiuto all'utente.",
    "langSelector": "Seleziona la lingua:",
    "test": "Ciao Mondo",
    "welcomeMsg":"Benvenuto nell'applicazione di demo di Trinkle WebComponents.",
    "param.blueness": "Blu",
    "apps.general.exit-without-saving": "Stai per uscire con modifiche non salvate. I tuoi progressi andranno persi. Vuoi continuare?",
    "tooltip.view.perspective": "Attiva/disattiva vista prospettica.",
    "tooltip.view.fit": "Adatta allo schermo.",
    "tooltip.view.iso": "Vista isometrica.",
    "tooltip.view.front": "Attiva/disattiva vista frontale/posteriore.",
    "tooltip.view.right": "Attiva/disattiva vista destra/sinistra.",
    "tooltip.view.top": "Attiva/disattiva vista superiore/inferiore.",
    "tooltip.apps.home": "Torna alla Suite di Applicazioni.",
    "tooltip.state.undo": "Annulla.",
    "tooltip.state.redo": "Ripeti.",
    "tooltip.session.new": "Nuova sessione.",
    "tooltip.session.restore": "Ripristina sessione.",
    "tooltip.session.save": "Salva sessione.",
    "base.app.title": "Demo (IT)",
    "Base.ErrorHeader": "Errore",
    "Base.ErrorInfo.ErrorDescription.Generic": "Si è verificato un errore imprevisto",
    "errorPanel.label.timestamp": "Timestamp",
    "errorPanel.label.sessionId": "ID sessione",
    "errorPanel.label.error": "Errore",
    "errorPanel.label.serverCode": "Codice server",
    "Base.ErrorPanel.Button.CopyToClipboard": "Copia negli appunti",
    "Base.ErrorPanel.Button.Undo": "Annulla",
    "Base.AppTitle": "Suite di Applicazioni",
    "tooltip.feature.help": "Aiuto",
    "tooltip.feature.settings": "Opzioni",
    "tooltip.feature.toggle-workpiece-view": "Mostra/Nascondi la pezza",
    "tooltip.feature.transfer-mesh": "Trasferisci la mesh"
  },
  "ko":{
    "helpTitle": "도움말",
    "helpText": "이 텍스트는 사용자에게 도움을 제공하는 데 사용됩니다.",
    "langSelector": "언어 선택:",
    "test": "안녕하세요 세계",
    "welcomeMsg":"Trinkle WebComponents 데모 애플리케이션에 오신 것을 환영합니다.",
    "param.blueness": "파랑",
    "apps.general.exit-without-saving": "저장되지 않은 변경 사항이 있습니다. 종료하면 진행 상황이 손실됩니다. 계속하시겠습니까?",
    "tooltip.view.perspective": "원근법 보기 전환.",
    "tooltip.view.fit": "화면에 맞추기.",
    "tooltip.view.iso": "등각 투영 보기.",
    "tooltip.view.front": "전면/후면 보기 전환.",
    "tooltip.view.right": "오른쪽/왼쪽 보기 전환.",
    "tooltip.view.top": "상단/하단 보기 전환.",
    "tooltip.apps.home": "앱 스위트로 돌아가기.",
    "tooltip.state.undo": "실행 취소.",
    "tooltip.state.redo": "다시 실행.",
    "tooltip.session.new": "새 세션.",
    "tooltip.session.restore": "세션 복원.",
    "tooltip.session.save": "세션 저장.",
    "base.app.title": "데모 (KO)",
    "Base.ErrorHeader": "오류",
    "Base.ErrorInfo.ErrorDescription.Generic": "예기치 않은 오류가 발생했습니다",
    "errorPanel.label.timestamp": "타임스탬프",
    "errorPanel.label.sessionId": "세션 ID",
    "errorPanel.label.error": "오류",
    "errorPanel.label.serverCode": "서버 코드",
    "Base.ErrorPanel.Button.CopyToClipboard": "클립보드에 복사",
    "Base.ErrorPanel.Button.Undo": "실행 취소",
    "Base.AppTitle": "앱 스위트",
    "tooltip.feature.help": "도움말",
    "tooltip.feature.settings": "설정",
    "tooltip.feature.toggle-workpiece-view": "작업 피스 보기/숨김",
    "tooltip.feature.transfer-mesh": "메시 전송"
    
  },
  "pt":{
    "helpTitle": "Ajuda",
    "helpText": "Este texto é usado para fornecer ajuda ao usuário.",
    "langSelector": "Selecione o idioma:",
    "test": "Olá Mundo",
    "welcomeMsg":"Bem-vindo à aplicação de demonstração de Trinkle WebComponents.",
    "param.blueness": "Azul",
    "apps.general.exit-without-saving": "Você está prestes a sair com alterações não salvas. Seu progresso será perdido. Deseja continuar?",
    "tooltip.view.perspective": "Alternar vista em perspectiva.",
    "tooltip.view.fit": "Ajustar à tela.",
    "tooltip.view.iso": "Vista isométrica.",
    "tooltip.view.front": "Alternar vista frontal/traseira.",
    "tooltip.view.right": "Alternar vista direita/esquerda.",
    "tooltip.view.top": "Alternar vista superior/inferior.",
    "tooltip.apps.home": "Voltar à Suite de Aplicativos.",
    "tooltip.state.undo": "Desfazer.",
    "tooltip.state.redo": "Refazer.",
    "tooltip.session.new": "Nova sessão.",
    "tooltip.session.restore": "Restaurar sessão.",
    "tooltip.session.save": "Salvar sessão.",
    "base.app.title": "Demo (PT)",
    "Base.ErrorHeader": "Erro",
    "Base.ErrorInfo.ErrorDescription.Generic": "Ocorreu um erro inesperado",
    "errorPanel.label.timestamp": "Timestamp",
    "errorPanel.label.sessionId": "ID da sessão",
    "errorPanel.label.error": "Erro",
    "errorPanel.label.serverCode": "Código do servidor",
    "Base.ErrorPanel.Button.CopyToClipboard": "Copiar para a área de transferência",
    "Base.ErrorPanel.Button.Undo": "Desfazer",
    "Base.AppTitle": "Suite de Aplicativos",
    "tooltip.feature.help": "Ajuda",
    "tooltip.feature.settings": "Opções",
    "tooltip.feature.toggle-workpiece-view": "Mostrar/Ocultar a peça",
    "tooltip.feature.transfer-mesh": "Transferir a malha"
  },
  "ukr":{
    "helpTitle": "Допомога",
    "helpText": "Цей текст використовується для надання допомоги користувачу.",
    "langSelector": "Виберіть мову:",
    "test": "Привіт Світ",
    "welcomeMsg":"Ласкаво просимо до демонстрації Trinkle WebComponents.",
    "param.blueness": "Синій",
    "apps.general.exit-without-saving": "Ви збираєтеся вийти, не зберігши зміни. Ваш прогрес буде втрачено. Бажаєте продовжити?",
    "tooltip.view.perspective": "Перемкнути перспективний вигляд.",
    "tooltip.view.fit": "Підігнати під екран.",
    "tooltip.view.iso": "Ізометричний вигляд.",
    "tooltip.view.front": "Перемкнути передній/задній вигляд.",
    "tooltip.view.right": "Перемкнути правий/лівий вигляд.",
    "tooltip.view.top": "Перемкнути верхній/нижній вигляд.",
    "tooltip.apps.home": "Повернутися до набору додатків.",
    "tooltip.state.undo": "Скасувати.",
    "tooltip.state.redo": "Повторити.",
    "tooltip.session.new": "Нова сесія.",
    "tooltip.session.restore": "Відновити сесію.",
    "tooltip.session.save": "Зберегти сесію.",
    "base.app.title": "Демонстрація (UK)",
    "Base.ErrorHeader": "Помилка",
    "Base.ErrorInfo.ErrorDescription.Generic": "Сталася несподівана помилка",
    "errorPanel.label.timestamp": "Timestamp",
    "errorPanel.label.sessionId": "ID сесії",
    "errorPanel.label.error": "Помилка",
    "errorPanel.label.serverCode": "Код сервера",
    "Base.ErrorPanel.Button.CopyToClipboard": "Копіювати в буфер обміну",
    "Base.ErrorPanel.Button.Undo": "Скасувати",
    "Base.AppTitle": "Набір додатків",
    "tooltip.feature.help": "Допомога",
    "tooltip.feature.settings": "Опції",
    "tooltip.feature.toggle-workpiece-view": "Показати/Сховати деталь",
    "tooltip.feature.transfer-mesh": "Передати сітку"
  },
  "dk":{
    "helpTitle": "Hjælp",
    "helpText": "Denne tekst bruges til at give hjælp til brugeren.",
    "langSelector": "Vælg sprog:",
    "test": "Hej Verden",
    "welcomeMsg":"Velkommen til Trinkle WebComponents Demo-applikationen.",
    "param.blueness": "Blå",
    "apps.general.exit-without-saving": "Du er ved at afslutte med ikke-gemte ændringer. Dit fremskridt vil gå tabt. Vil du fortsætte?",
    "tooltip.view.perspective": "Skift perspektivvisning.",
    "tooltip.view.fit": "Tilpas til skærm.",
    "tooltip.view.iso": "Isometrisk visning.",
    "tooltip.view.front": "Skift front/bag visning.",
    "tooltip.view.right": "Skift højre/venstre visning.",
    "tooltip.view.top": "Skift top/bund visning.",
    "tooltip.apps.home": "Tilbage til App Suite.",
    "tooltip.state.undo": "Fortryd.",
    "tooltip.state.redo": "Gentag.",
    "tooltip.session.new": "Ny session.",
    "tooltip.session.restore": "Gendan session.",
    "tooltip.session.save": "Gem session.",
    "base.app.title": "Demo (DK)",
    "Base.ErrorHeader": "Fejl",
    "Base.ErrorInfo.ErrorDescription.Generic": "Der opstod en uventet fejl",
    "errorPanel.label.timestamp": "Timestamp",
    "errorPanel.label.sessionId": "Session ID",
    "errorPanel.label.error": "Fejl",
    "errorPanel.label.serverCode": "Serverkode",
    "Base.ErrorPanel.Button.CopyToClipboard": "Kopier til udklipsholder",
    "Base.ErrorPanel.Button.Undo": "Fortryd",
    "Base.AppTitle": "App Suite",
    "tooltip.feature.help": "Hjælp",
    "tooltip.feature.settings": "Indstillinger",
    "tooltip.feature.toggle-workpiece-view": "Vis/Skjul værkstød",
    "tooltip.feature.transfer-mesh": "Overfør mesh"
  },
  "nl":{
    "helpTitle": "Hulp",
    "helpText": "Deze tekst wordt gebruikt om hulp te bieden aan de gebruiker.",
    "langSelector": "Kies taal:",
    "test": "Hallo Wereld",
    "welcomeMsg":"Welkom bij de Trinkle WebComponents Demo-toepassing.",
    "param.blueness": "Blauw",
    "apps.general.exit-without-saving": "U staat op het punt af te sluiten met niet-opgeslagen wijzigingen. Uw voortgang gaat verloren. Wilt u doorgaan?",
    "tooltip.view.perspective": "Perspectiefweergave in-/uitschakelen.",
    "tooltip.view.fit": "Aanpassen aan scherm.",
    "tooltip.view.iso": "Isometrische weergave.",
    "tooltip.view.front": "Voor-/achteraanzicht schakelen.",
    "tooltip.view.right": "Rechts-/linksaanzicht schakelen.",
    "tooltip.view.top": "Boven-/onderaanzicht schakelen.",
    "tooltip.apps.home": "Terug naar App Suite.",
    "tooltip.state.undo": "Ongedaan maken.",
    "tooltip.state.redo": "Opnieuw uitvoeren.",
    "tooltip.session.new": "Nieuwe sessie.",
    "tooltip.session.restore": "Sessie herstellen.",
    "tooltip.session.save": "Sessie opslaan.",
    "base.app.title": "Demo (NL)",
    "Base.ErrorHeader": "Fout",
    "Base.ErrorInfo.ErrorDescription.Generic": "Er is een onverwachte fout opgetreden",
    "errorPanel.label.timestamp": "Timestamp",
    "errorPanel.label.sessionId": "Sessie-ID",
    "errorPanel.label.error": "Fout",
    "errorPanel.label.serverCode": "Servercode",
    "Base.ErrorPanel.Button.CopyToClipboard": "Kopieer naar klembord",
    "Base.ErrorPanel.Button.Undo": "Ongedaan maken",
    "Base.AppTitle": "App Suite",
    "tooltip.feature.help": "Hulp",
    "tooltip.feature.settings": "Opties",
    "tooltip.feature.toggle-workpiece-view": "Werkstuk weergeven/verbergen",
    "tooltip.feature.transfer-mesh": "Mesh overdragen"
  },
  "pl":{
    "helpTitle": "Pomoc",
    "helpText": "Ten tekst jest używany do dostarczania pomocy użytkownikowi.",
    "langSelector": "Wybierz język:",
    "test": "Cześć Świat",
    "welcomeMsg":"Witaj w demonstracji Trinkle WebComponents.",
    "param.blueness": "Niebieski",
    "apps.general.exit-without-saving": "Zamierzasz wyjść z niezapisanymi zmianami. Twoje postępy zostaną utracone. Czy chcesz kontynuować?",
    "tooltip.view.perspective": "Przełącz widok perspektywiczny.",
    "tooltip.view.fit": "Dopasuj do ekranu.",
    "tooltip.view.iso": "Widok izometryczny.",
    "tooltip.view.front": "Przełącz widok przód/tył.",
    "tooltip.view.right": "Przełącz widok prawo/lewo.",
    "tooltip.view.top": "Przełącz widok góra/dół.",
    "tooltip.apps.home": "Powrót do App Suite.",
    "tooltip.state.undo": "Cofnij.",
    "tooltip.state.redo": "Ponów.",
    "tooltip.session.new": "Nowa sesja.",
    "tooltip.session.restore": "Przywróć sesję.",
    "tooltip.session.save": "Zapisz sesję.",
    "base.app.title": "Demo (PL)",
    "Base.ErrorHeader": "Błąd",
    "Base.ErrorInfo.ErrorDescription.Generic": "Wystąpił nieoczekiwany błąd",
    "errorPanel.label.timestamp": "Timestamp",
    "errorPanel.label.sessionId": "ID sesji",
    "errorPanel.label.error": "Błąd", 
    "errorPanel.label.serverCode": "Kod serwera", 
    "Base.ErrorPanel.Button.CopyToClipboard": "Skopiuj do schowka",
    "Base.ErrorPanel.Button.Undo": "Cofnij",
    "Base.AppTitle": "App Suite",
    "tooltip.feature.help": "Pomoc",
    "tooltip.feature.settings": "Opcje",
    "tooltip.feature.toggle-workpiece-view": "Pokaż/Ukryj element",
    "tooltip.feature.transfer-mesh": "Przekaż siatkę"
  },
  "swe":{
    "helpTitle": "Hjälp",
    "helpText": "Denna text används för att ge hjälp till användaren.",
    "langSelector": "Välj språk:",
    "test": "Hej Världen",
    "welcomeMsg":"Välkommen till Trinkle WebComponents Demo-applikationen.",
    "param.blueness": "Blå",
    "apps.general.exit-without-saving": "Du är på väg att avsluta med osparade ändringar. Dina framsteg kommer att förloras. Vill du fortsätta?",
    "tooltip.view.perspective": "Växla perspektivvy.",
    "tooltip.view.fit": "Anpassa till skärmen.",
    "tooltip.view.iso": "Isometrisk vy.",
    "tooltip.view.front": "Växla fram-/bakvy.",
    "tooltip.view.right": "Växla höger-/vänstervy.",
    "tooltip.view.top": "Växla topp-/bottenvy.",
    "tooltip.apps.home": "Tillbaka till App Suite.",
    "tooltip.state.undo": "Ångra.",
    "tooltip.state.redo": "Gör om.",
    "tooltip.session.new": "Ny session.",
    "tooltip.session.restore": "Återställ session.",
    "tooltip.session.save": "Spara session.",
    "base.app.title": "Demo (SV)"
  },
  "nor":{
    "helpTitle": "Hjelp",
    "helpText": "Denne teksten brukes til å gi hjelp til brukeren.",
    "langSelector": "Velg språk:",
    "test": "Hei Verden",
    "welcomeMsg":"Velkommen til Trinkle WebComponents Demo-applikationen.",
    "param.blueness": "Blå",
    "apps.general.exit-without-saving": "Du er i ferd med å avslutte med ulagrede endringer. Fremgangen din vil gå tapt. Vil du fortsette?",
    "tooltip.view.perspective": "Bytt perspektivvisning.",
    "tooltip.view.fit": "Tilpass til skjermen.",
    "tooltip.view.iso": "Isometrisk visning.",
    "tooltip.view.front": "Bytt front-/bakvisning.",
    "tooltip.view.right": "Bytt høyre-/venstrevisning.",
    "tooltip.view.top": "Bytt topp-/bunnvisning.",
    "tooltip.apps.home": "Tilbake til App Suite.",
    "tooltip.state.undo": "Angre.",
    "tooltip.state.redo": "Gjenta.",
    "tooltip.session.new": "Ny økt.",
    "tooltip.session.restore": "Gjenopprett økt.",
    "tooltip.session.save": "Lagre økt.",
    "base.app.title": "Demo (NO)"
  },
  "fin":{
    "helpTitle": "Apua",
    "helpText": "Tämä teksti käytetään apua käyttäjälle.",
    "langSelector": "Valitse kieli:",
    "test": "Hei Maailma",
    "welcomeMsg":"Tervetuloa Trinkle WebComponents Demo-sovellukseen.", 
    "param.blueness": "Sininen",
    "apps.general.exit-without-saving": "Olet poistumassa tallentamatta muutoksia. Edistymisesi menetetään. Haluatko jatkaa?",
    "tooltip.view.perspective": "Vaihda perspektiivinäkymää.",
    "tooltip.view.fit": "Sovita näyttöön.",
    "tooltip.view.iso": "Isometrinen näkymä.",
    "tooltip.view.front": "Vaihda etu-/takanäkymää.",
    "tooltip.view.right": "Vaihda oikea-/vasennäkymää.",
    "tooltip.view.top": "Vaihda ylä-/alanäkymää.",
    "tooltip.apps.home": "Takaisin sovelluskokoelmaan.",
    "tooltip.state.undo": "Kumoa.",
    "tooltip.state.redo": "Tee uudelleen.",
    "tooltip.session.new": "Uusi istunto.",
    "tooltip.session.restore": "Palauta istunto.",
    "tooltip.session.save": "Tallenna istunto.",
    "base.app.title": "Demo (FI)"
  },
  "hun":{
    "helpTitle": "Segítség",
    "helpText": "Ezt a szöveget a felhasználónak segítséget nyújtásra használjuk.",
    "langSelector": "Válasszon nyelvet:",
    "test": "Hello Világ",
    "welcomeMsg":"Üdvözlünk a Trinkle WebComponents Demo-alkalmazásban.",
    "param.blueness": "Kék",
    "apps.general.exit-without-saving": "El fogja hagyni az alkalmazást mentetlen változtatásokkal. A haladása elvész. Szeretné folytatni?",
    "tooltip.view.perspective": "Perspektivikus nézet váltása.",
    "tooltip.view.fit": "Képernyőhöz igazítás.",
    "tooltip.view.iso": "Izometrikus nézet.",
    "tooltip.view.front": "Elülső/hátsó nézet váltása.",
    "tooltip.view.right": "Jobb/bal nézet váltása.",
    "tooltip.view.top": "Felső/alsó nézet váltása.",
    "tooltip.apps.home": "Vissza az alkalmazáscsomaghoz.",
    "tooltip.state.undo": "Visszavonás.",
    "tooltip.state.redo": "Újra.",
    "tooltip.session.new": "Új munkamenet.",
    "tooltip.session.restore": "Munkamenet visszaállítása.",
    "tooltip.session.save": "Munkamenet mentése.",
    "base.app.title": "Demo (HU)"
  }
}